import React, { useState } from 'react';
import { FiFilter, FiCalendar, FiCheck } from 'react-icons/fi';

const SavedJobsFilterBar = ({ onApplyFilters }) => {
  const [dateFilter, setDateFilter] = useState('all');
  const [applicationFilter, setApplicationFilter] = useState('all'); // 'all' | 'not_applied' | 'applied'

  const handleApplicationFilterChange = (value) => {
    setApplicationFilter(value);
    applyFilters(dateFilter, value);
  };

  const handleDateChange = (value) => {
    setDateFilter(value);
    applyFilters(value, applicationFilter);
  };

  const applyFilters = (date, application) => {
    onApplyFilters({
      dateFilter: date,
      applicationFilter: application
    });
  };

  const hasActiveFilters = dateFilter !== 'all' || applicationFilter !== 'all';

  return (
    <div className="bg-white p-4 rounded-lg shadow mb-6 flex flex-wrap items-center gap-4">
      <div className="flex items-center">
        <FiFilter className="h-5 w-5 text-gray-500 mr-2" />
        <span className="font-medium text-gray-700">Filters:</span>
      </div>

      <div className="flex items-center">
        <FiCalendar className="h-4 w-4 text-gray-500 mr-2" />
        <span className="text-sm text-gray-700 mr-2">Date added:</span>
        <select
          value={dateFilter}
          onChange={(e) => handleDateChange(e.target.value)}
          className="text-sm border-gray-300 rounded-md shadow-sm focus:border-primary-300 focus:ring focus:ring-primary-200 focus:ring-opacity-50"
        >
          <option value="all">All time</option>
          <option value="7days">Last 7 days</option>
          <option value="30days">Last 30 days</option>
          <option value="90days">Last 90 days</option>
        </select>
      </div>

      <div className="flex items-center flex-wrap gap-2">
        <span className="text-sm text-gray-700 mr-2">Show:</span>
        {[
          { value: 'all', label: 'All' },
          { value: 'not_applied', label: 'Not applied' },
          { value: 'applied', label: 'Applied' }
        ].map(({ value, label }) => (
          <button
            key={value}
            onClick={() => handleApplicationFilterChange(value)}
            className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
              applicationFilter === value
                ? 'bg-primary-100 text-primary-800 border-primary-300'
                : 'bg-gray-100 text-gray-800 border-gray-200'
            } border`}
          >
            {applicationFilter === value && <FiCheck className="mr-1 h-3 w-3" />}
            {label}
          </button>
        ))}
      </div>

      {hasActiveFilters && (
        <button
          onClick={() => {
            setDateFilter('all');
            setApplicationFilter('all');
            applyFilters('all', 'all');
          }}
          className="text-xs text-primary-600 hover:text-primary-800 ml-auto"
        >
          Clear filters
        </button>
      )}
    </div>
  );
};

export default SavedJobsFilterBar;
